import { SignalCellularOutlineIcon } from './SignalCellularOutlineIcon';

/**
 * author: Michael Richins
 * id AA11AD00-4A6D-4D7F-911C-137CDDCF34B6
 * name signal-cellular-outline
 * version: 2.2.43
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/signal-cellular-outline.svg
 * tags
 * - Cellphone / Phone 
 */
export const SignalCellular0Icon = SignalCellularOutlineIcon;
export default SignalCellular0Icon